(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchisesEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#franchisesedit-local_phone').on('change', function click(e)
		{
			Adzuki.StatusMessage('Warning', 'The phone number entered here will be used to register your business with the cruise lines.  It cannot be a toll free number.  If you want to change this number email us at <a href="mailto: compliance@cruiseplanners.com">compliance@cruiseplanners.com</a>. CHANGE FEES WILL APPLY</small>');
		});

		// $('#franchisesedit-excursion_company').on('change', function click(e)
		// {
		// 	var $self = $(this);

		// 	if ($self.val() === 'shore_excursions_group') {
		// 		$('.seg-fields').removeClass('hidden');
		// 		$('#franchisesedit-do_not_send_client_data_seg').prop('disabled', false);
		// 	} else {
		// 		$('.seg-fields').addClass('hidden');
		// 		$('#franchisesedit-do_not_send_client_data_seg').prop('checked', false);
		// 	}
		// });
	};

	// form.confirmation = function confirmation(response)
	// {
	// 	var $jForm;

	// 	if (response.data.response_code === "previous_seg") {

	// 		Adzuki.CustomConfirm({
	// 			body   : response.data.message,
	// 			confirm: function yes() {
	// 				$jForm = $('form[name="' + form.name + '"]');

	// 				// set hidden input indicating that the user wants to proceed, so we do not throw a confirm again
	// 				$('#franchisesedit-confirmed_excursion_company').val(1);
	// 				$jForm.submit();
	// 			}
	// 		});
	// 	}
	// };
}(jQuery, window.Adzuki || {}));
